var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-button',{attrs:{"color":"primary","type":"filled"},on:{"click":_vm.scrap}},[_vm._v("Scrap")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }